import React from "react";
import AlliesOrRecognitions from "views/AboutUs/components/AlliesOrRecognitions/AlliesOrRecognitions";

const Allies: React.FC = () => {
  return (
    <section className="bg_primary_300 p_y_xxxl">
      <div className="dso_container">
        <AlliesOrRecognitions type="allies" />
      </div>
    </section>
  );
};

export default Allies;
